import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {
  Customer,
  defaultImportSettings,
  ImportSettings,
} from "../../../../core/models";
import {FormControl, FormGroup} from "@angular/forms";

@Component({
    selector: 'app-import-settings',
    templateUrl: './import-settings.component.html',
    styleUrls: ['./import-settings.component.scss'],
    standalone: false
})
export class ImportSettingsComponent implements OnChanges {

  constructor() {
    this.form.disable();
  }

  @Input() settings: ImportSettings | undefined;
  @Output() saveSettings: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  customer: Customer;
  loading: boolean = false;
  value: ImportSettings = {
    ...defaultImportSettings
  };
  form: FormGroup = new FormGroup({
    show_import_project_statuses: new FormControl<boolean>(false),
  });

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['settings']) {
      this.settings = changes['settings'].currentValue;
      if (this.settings) {
        this.value = { ...defaultImportSettings, ...this.settings };
      }
      this.form.patchValue(this.value);
    }
  }

  doEdit(): void {
    this.form.enable();
  }

  doCancel(): void {
    this.value = { ...defaultImportSettings, ...this.settings };
    this.form.reset(this.value);
    this.form.disable();
  }

  doSave(): void {
    this.saveSettings.emit(this.form);
    this.form.disable();
  }
}
